var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key",class:{
    'black-key': _vm.pianoKey.type === 'black',
    'white-key': _vm.pianoKey.type === 'white',
  },on:{"mousedown":_vm.keyClick}})}
var staticRenderFns = []

export { render, staticRenderFns }